type CodeEditorProps = {
  editorCode: string;
  onChange: (code: string) => void;
  onRender: () => void;
  onCopy: () => void;
  onExportMmd: () => void;
  editorRef: React.RefObject<HTMLTextAreaElement | null>;
};

export function CodeEditor({ editorCode, onChange, onRender, onCopy, onExportMmd, editorRef }: CodeEditorProps) {
  return (
    <div className="ds-code-editor">
      <div className="ds-code-editor__head">
        <span className="ds-code-editor__head-title">Mermaid Source</span>
        <div className="ds-code-editor__head-actions">
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onCopy}>
            Copy
          </button>
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onRender}>
            Render
          </button>
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onExportMmd}>
            Export .mmd
          </button>
        </div>
      </div>

      <textarea
        ref={editorRef}
        className="ds-code-editor__textarea"
        value={editorCode}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Mermaid code..."
        spellCheck={false}
      />
    </div>
  );
}
